import { render, staticRenderFns } from "./MinusCircle.vue?vue&type=template&id=347b6f1a&"
import script from "./MinusCircle.vue?vue&type=script&lang=js&"
export * from "./MinusCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports